function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isIndeterminate } from "./util";
export var keyReducer = function keyReducer(state, action) {
  var newState = _objectSpread({}, state);

  switch (action.type) {
    case 'one':
      {
        var index = state.indexMap[action.currentItem.key]; // 跳过重复的操作，导致计算错误

        if (state.checkGroup[index] === action.checked) {
          return state;
        }

        var newChecks = _toConsumableArray(state.checkGroup);

        newChecks[index] = action.checked;
        newState.checkGroup = newChecks;

        if (action.checked === 'all' && state.checkGroup[index] === 'part' || action.checked === 'part' && state.checkGroup[index] === 'all') {} else {
          newState.count += action.checked === 'all' || action.checked === 'part' ? 1 : -1;
        }

        break;
      }

    case 'all':
      {
        // 跳过不需要的操作，没有children
        if (Object.keys(state.indexMap).length === 0) {
          return state;
        }

        newState.checkGroup = state.checkGroup.map(function () {
          return action.checked;
        });
        newState.count = action.checked === 'all' ? newState.checkGroup.length : 0;
        break;
      }

    case 'clone':
      {
        var children = action.currentItem.children;
        var _checkGroup = [];
        var expandGroup = [];
        var count = 0;
        var indexMap = {};
        newState.checkGroup = children.reduce(function (res, _ref, index) {
          var _state$checkGroup$i, _state$expandGroup$i;

          var key = _ref.key;
          var i = state.indexMap[key];
          var checked = (_state$checkGroup$i = state.checkGroup[i]) !== null && _state$checkGroup$i !== void 0 ? _state$checkGroup$i : 'none';
          var expanded = (_state$expandGroup$i = state.expandGroup[i]) !== null && _state$expandGroup$i !== void 0 ? _state$expandGroup$i : action.expanded(key);

          _checkGroup.push(checked);

          expandGroup.push(expanded);
          indexMap[key] = index;

          if (checked === 'all' || checked === 'part') {
            count++;
          }

          return res;
        }, _checkGroup);
        newState.checkGroup = _checkGroup;
        newState.count = count;
        newState.expandGroup = expandGroup;
        newState.indexMap = indexMap;
      }
  }

  newState.selected = [];
  newState.selectedMap = {};
  newState.unSelected = [];
  newState.unSelectedMap = {};
  newState.partialSelected = [];
  newState.partialSelectedMap = {};
  var checkGroup = newState.checkGroup,
      selected = newState.selected,
      selectedMap = newState.selectedMap,
      unSelected = newState.unSelected,
      unSelectedMap = newState.unSelectedMap,
      partialSelected = newState.partialSelected,
      partialSelectedMap = newState.partialSelectedMap;

  var p = function p(item) {
    var index = newState.indexMap[item.key];
    var checked = checkGroup[index];

    switch (checked) {
      case 'all':
        selected.push(item);
        selectedMap[item.key] = index;
        break;

      case 'part':
        partialSelected.push(item);
        partialSelectedMap[item.key] = index;
        break;

      case 'none':
        unSelected.push(item);
        unSelectedMap[item.key] = index;
        break;
    }
  };

  if (action.type === 'clone') {
    action.currentItem.children.forEach(p);
  } else {
    state.selected.forEach(p);
    state.unSelected.forEach(p);
    state.partialSelected.forEach(p);
  }

  newState.indeterminate = isIndeterminate(selected, unSelected, partialSelected);
  return newState;
};